module.exports = __webpack_public_path__ + "static/media/item_5_38_comp.fd7a46e8.png";